import { SkillId } from "../domain/skills.js";
import type { CampaignSkillConfig } from "./types.js";

function createCampaignSkills(nameKeyPrefix: string): CampaignSkillConfig {
  return {
    hiddenSkillIds: [SkillId.GEM_DEPLOYMENT_TIME],
    nameKeyPrefix,
    descriptionKeyPrefix: `${nameKeyPrefix}.desc`,
  };
}

export const engineSkills: CampaignSkillConfig = {
  hiddenSkillIds: [SkillId.GEM_DEPLOYMENT_TIME],
  nameKeyPrefix: "skill",
  descriptionKeyPrefix: "skill.desc",
};

export const sanctifiedSkills = createCampaignSkills("sanctified.skill");
export const buddhaSkills = createCampaignSkills("buddha.skill");
